import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true, state: {
        visitors: {
            data: [],
            current_page: 1, total: 0, per_page: 10
        },
        visitor: [],
        loading: false,
        visitor_otp_tracker: {},
        tenant_otp_tracker: {},
        tenant_otp_tracker_sent: false,
        visitor_otp_tracker_sent: false,
        visitor_otp_verified: false,
        visitor_checkin_approved: false,
        errors: {
            data: {
                errors: {
                    property_id: [],
                    property_unit_id: [],
                    visit_reason: "",
                    email: [],
                    name: [],
                    phone: [],
                    in_company: [],
                }
            }
        },
        has_errors: false,
        downloading_visitors: false,
        sending_visitor_comment: false
    },
    getters: {
        visitor: state => state.visitor,
        visitors: state => state.visitors,
        loading: state => state.loading,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        downloading_visitors: state => state.downloading_visitors,
        sending_visitor_comment: state => state.sending_visitor_comment,
        visitor_otp_tracker: state => state.visitor_otp_tracker,
        tenant_otp_tracker: state => state.tenant_otp_tracker,
        tenant_otp_tracker_sent: state => state.tenant_otp_tracker_sent,
        visitor_otp_verified: state => state.visitor_otp_verified,
        visitor_otp_tracker_sent: state => state.visitor_otp_tracker_sent,
        visitor_checkin_approved: state => state.visitor_checkin_approved,
    },
    mutations: {

        setDownloadingLoading(state, val) {
            state.downloading_visitors = val
        },
        setLoading(state, val) {
            state.loading = val
        },
        setVisitorOtpTracker(state, val) {
            state.visitor_otp_tracker = val
        },
        setTenantOtpTracker(state, val) {
            state.tenant_otp_tracker = val
        },
        setTenantOtpTrackerSent(state, val) {
            state.tenant_otp_tracker_sent = val
        },
        setVisitorOtpTrackerSent(state, val) {
            state.visitor_otp_tracker_sent = val
        },
        setVisitorCheckinApproved(state, val) {
            state.visitor_checkin_approved = val
        },
        setVisitorOtpVerified(state, val) {
            state.visitor_otp_verified = val
        },
        setVisitors(state, data) {
            state.visitors = data;
        },
        setVisitor(state, data) {
            state.visitor = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            property_id: [],
                            property_unit_id: [],
                            visit_reason: [],
                            email: [],
                            name: [],
                            phone: [],
                            in_company: [],
                        }
                    }
                };
            }
        }
    }, actions: {
        async getVisitors({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'visitor/list', {root: true});
                const response = await api.getVisitors(filters);
                commit('setVisitors', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'visitor/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async getVisitor({commit}, id) {
            try {
                commit('activateLoading', 'visitor/list', {root: true});
                const response = await api.getVisitor(id);
                commit('setVisitor', response.data);
                commit('deactivateLoading', 'visitor/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async checkoutVisitor({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.checkoutVisitor(data);
                ElMessage.success('Visitor checked out successfully!');
                commit('setLoading', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error updating Visitor!');
            }
        },
        async sendOTP({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                commit('setVisitorOtpTrackerSent', false)
                const response = await api.sendOTP(data);
                commit('setVisitorOtpTracker', response?.tracker || "")
                commit('setVisitorOtpTrackerSent', true)
                ElMessage.success('OTP sent successfully!');
                commit('setLoading', false)
            } catch (e) {
                commit('setVisitorOtpTrackerSent', false)
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error sending Visitor OTP!');
            }
        },
        async approveVisitorCheckin({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                commit('setVisitorCheckinApproved', false)
                const response = await api.approveVisitorCheckin(data);
                commit('setVisitorOtpTracker', response?.tracker || "")
                commit('setVisitorCheckinApproved', true)
                ElMessage.success('Visitor checkin approved successfully!');
                commit('setLoading', false)
            } catch (e) {
                commit('setVisitorCheckinApproved', false)
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error approving Visitor Checkin. Please try again later.');
            }
        },

        async verifyTenantApproval({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                commit('setVisitorCheckinApproved', false)
                await api.verifyTenantApproval(data);
                commit('setVisitorCheckinApproved', true)
                commit('setLoading', false)
            } catch (e) {
                commit('setVisitorCheckinApproved', false)
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
            }
        },

        async verifyOTP({dispatch, commit}, data) {
            try {
                commit('setVisitorOtpVerified', false)
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.verifyVisitorOtp(data);
                commit('setVisitorOtpVerified', true)
                ElMessage.success('OTP sent successfully!');
                commit('setLoading', false)
            } catch (e) {
                commit('setVisitorOtpVerified', false)
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error sending Visitor OTP!');
            }
        },
        async sendTenantOTP({dispatch, commit}, data) {
            try {
                commit('setTenantOtpTrackerSent', false)
                commit('setLoading', true)
                commit('hasErrors', false)
                const response = await api.sendTenantOTP(data);
                commit('setTenantOtpTracker', response?.tracker || "")
                commit('setTenantOtpTrackerSent', true)
                ElMessage.success('OTP sent successfully!');
                commit('setLoading', false)
            } catch (e) {
                commit('setTenantOtpTracker', {})
                commit('setTenantOtpTrackerSent', false)
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error sending Visitor OTP!');
            }
        },

        async createVisitors({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                commit('setLoading', true)
                await api.createVisitor(data);
                commit('setLoading', false)
                ElMessage.success('Visitor created successfully!');
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                commit('setLoading', false)
                ElMessage.error('Error creating Visitor!');
            }
        },

        async editVisitor({dispatch}, data) {
            try {
                await api.editVisitor(data);
                dispatch('getVisitors', data.id);
                ElMessage.success('Visitor updated successfully!');
            } catch (e) {
                ElMessage.error('Error updating Visitor');
            }
        },

        async deleteVisitor({dispatch}, data) {
            try {
                await api.deleteVisitor(data);
                dispatch('getVisitors', data.id);
                ElMessage.success('Visitor removed successfully!');
            } catch (e) {
                ElMessage.error('Error removing Visitor');
            }
        },

        async downloadVisitorHistory({commit}, filters) {
            try {
                commit('setDownloadingLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();

                const response = await api.downloadVisitorHistory(filters);
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Visitors_' + fileName + '.xlsx');
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingLoading', false);
            } catch (e) {
                commit('setDownloadingLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

        async exportVisitorsReport({commit}, {filters, format}) {
            try {
                commit('setDownloadingLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportVisitorsReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Visitors_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingLoading', false);
            } catch (e) {
                commit('setDownloadingLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        }

    }
}
